import React, { useState, useEffect } from 'react';
import styles from './map-controls.css';
import ZoomInTwoToneIcon from '@mui/icons-material/ZoomInTwoTone';
import ZoomOutTwoToneIcon from '@mui/icons-material/ZoomOutTwoTone';

export function ZoomInButton({ mapRef }) {
    const handleZoomIn = () => {
        if (mapRef.current) {
            mapRef.current.zoomIn(0.45);
        }
    };

    return (
        <div className={styles.container}>
            <ZoomInTwoToneIcon onClick={handleZoomIn} />
        </div>
    );
}

export function ZoomOutButton({ mapRef }) {

    const handleZoomOut = () => {
        if (mapRef.current) {
            mapRef.current.zoomOut(0.45);
        }
    };
    return (
        <div className={styles.container}>
            <ZoomOutTwoToneIcon onClick={handleZoomOut} />
        </div>
    );
}
